module.exports = __webpack_public_path__ + "static/img/fraud.45fbf9fc.png";